import { render, staticRenderFns } from "./PropertyContract.vue?vue&type=template&id=20d9d457"
import script from "./PropertyContract.vue?vue&type=script&lang=js"
export * from "./PropertyContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports